import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { generateReport } from '../../app/store/actions/reports';
import { getStorageAddressTypesOptions } from '../../app/store/actions/storageAdressTypes';
import FilterDefault from '../../components/filters/FilterDefault';
import OneClickButton from '../../components/form/button';
import Form from '../../components/form/form';
import Select from '../../components/form/select';
import DualList from '../../components/pages/DualList';
import { PanelPage } from '../../components/pages/pages';
import { returnFiltersByRules } from './utils';
import ROUTES from '../../config/routes';
import ReportsBackgroundModal from '../../components/pages/reportsBackgroundModal';
import { getCapacityOptions } from '../../app/store/actions/capacities';

import { getAllCurves } from '../../app/store/actions/curves';

class ReportStockEmptyAddresses extends React.PureComponent {
  constructor() {
    super();

    this.breadcrumb = [
      {
        value: (<>
          <i className="fas fa-home fa-fw m-t-10 m-r-5" />
          {' '}
          {I18n.t('BEE12' /* Início */)}
                </>),
      },
      { value: I18n.t('BEE47' /* Relatórios */) },
      { value: I18n.t('BEE32' /* Estoque */) },
      { value: I18n.t('BEE1753' /* Endereços Vazios */), active: true },
    ];

    this.options = [
      {
        label: I18n.t('BEE82' /* Código */),
        value: 'code',
      }, {
        label: I18n.t('BEE1853' /* Nome */),
        value: 'name',
      }, {
        label: I18n.t('BEE145' /* Filial */),
        value: 'branchCode',
      }, {
        label: I18n.t('BEE200' /* Tipo */),
        value: 'type',
      }, {
        label: I18n.t('BEE1854' /* Setor */),
        value: 'sector',
      }, {
        label: I18n.t('BEE121' /* Rua */),
        value: 'street',
      }, {
        label: I18n.t('BEE281' /* Coluna */),
        value: 'column',
      }, {
        label: I18n.t('BEE283' /* Nível */),
        value: 'level',
      }, {
        label: I18n.t('BEE285' /* Gaveta */),
        value: 'drawer',
      }, {
        label: I18n.t('BEE207' /* Bloqueado */),
        value: 'blocked',
      }, {
        label: I18n.t('BEE1855' /* Tamanho */),
        value: 'size',
      }, {
        label: I18n.t('BEE386' /* Altura */),
        value: 'height',
      }, {
        label: I18n.t('BEE387' /* Largura */),
        value: 'width',
      }, {
        label: I18n.t('BEE388' /* Comprimento */),
        value: 'length',
      }, {
        label: I18n.t('BEE727' /* Capacidade (Volume) */),
        value: 'capacityVolume',
      }, {
        label: I18n.t('BEE726' /* Capacidade (Peso) */),
        value: 'capacityWeight',
      }, {
        label: I18n.t('BEE1754' /* Código Região */),
        value: 'rangeCode',
      }, {
        label: I18n.t('BEE697' /* Compartilha Endereço */),
        value: 'shareAddress',
      }, {
        label: I18n.t('BEE355' /* Curva */),
        value: 'curve',
      }, {
        label: I18n.t('BEE135' /* Observação */),
        value: 'note',
      }, {
        label: I18n.t('BEE575' /* Usuário de criação */),
        value: 'createdUser',
      }, {
        label: I18n.t('BEE578' /* Data de criação */),
        value: 'createdAt',
      }, {
        label: I18n.t('BEE576' /* Usuário de alteração */),
        value: 'updatedUser',
      }, {
        label: I18n.t('BEE577' /* Data de alteração */),
        value: 'updatedAt',
      },
    ];

    this.state = {
      selected: [],
      branchCodeFrom: '',
      branchCodeTo: '',
      codeFrom: '',
      codeTo: '',
      columnSide: 'both',
      sectorFrom: '',
      sectorTo: '',
      streetFrom: '',
      streetTo: '',
      columnFrom: '',
      columnTo: '',
      levelFrom: '',
      levelTo: '',
      drawerFrom: '',
      drawerTo: '',
      type: '',
      typeName: '',
      rangeFrom: '',
      rangeTo: '',
      listCurves: [],
      curves: [],
    };
  }

  async componentDidMount() {
    const listType = await this.props.getStorageAddressTypesOptions();

    this.getCurves();

    const allOption = { value: '', label: I18n.t('BEE793' /* Todos */) };
    listType.push(allOption);

    this.setState({
      listType,
    });

    const columnSideList = [
      { label: I18n.t('BEE203' /* Ambos */), value: 'both' },
      { label: I18n.t('BEE3398' /* Par */), value: 'even' },
      { label: I18n.t('BEE3399' /* Ímpar */), value: 'odd' },
    ];

    this.setState({
      columnSideList,
      columnSide: 'both',
      columnSideLabel: I18n.t('BEE203' /* Ambos */),
    });

    const dataOptions = await this.props.getCapacityOptions();

    this.setState({
      listStorageAddressSize: dataOptions?.storageAddressSizes,
    });
  }

  getCurves = async () => {
    await this.props.getAllCurves();

    const listCurves = this.props.curves.map((element) => {
      this.setState({
        [`${element.code}`]: true,
      });

      return {
        value: element.code,
        label: element.code,
      };
    });

    listCurves.push({ value: 'all', label: I18n.t('BEE2478' /* Todas as curvas estão selecionadas */) });

    this.setState({
      listCurves,
      curves: [{ value: 'all', label: I18n.t('BEE2478' /* Todas as curvas estão selecionadas */) }],
    });
  };

  createSelectDropDown = (value, attr, label, items, required = false) => (
    <div key={value} className="form-group row m-b-15" style={{ height: 40 }}>
      <label className="col-form-label col-md-2">{label}</label>
      <div className="col-md-4">
        <Select
          value={value.label ? value : ''}
          onChange={(e) => this.setValueDrop(attr, e)}
          options={items}
          isClearable
          placeholder={I18n.t('BEE144' /* Selecione... */)}
          required={required}
          styles={colourStyles}
        />
      </div>
    </div>
  );

  setValueDrop = async (attr, value) => {
    await this.setState({
      [`${attr}`]: value ? value.value : null,
      [`${attr}Name`]: value ? value.label : '',
    });

    if (attr === 'columnSide') {
      const { columnSide } = this.state;

      let columnSideLabel = '';

      const columnSideList = [
        { label: I18n.t('BEE203' /* Ambos */), value: 'both' },
        { label: I18n.t('BEE3398' /* Par */), value: 'even' },
        { label: I18n.t('BEE3399' /* Ímpar */), value: 'odd' },
      ];

      if (columnSide === 'both') {
        columnSideLabel = I18n.t('BEE203' /* Ambos */);
      } else if (columnSide === 'even') {
        columnSideLabel = I18n.t('BEE3398' /* Par */);
      } else if (columnSide === 'odd') {
        columnSideLabel = I18n.t('BEE3399' /* Ímpar */);
      }

      await this.setState({
        columnSideList,
        columnSide,
        columnSideLabel,
      });
    } else if (attr === 'size' && value) {
      this.props.addressSizesList.forEach((element) => {
        if (element.code === value.value) {
          this.setState({
            curve: element.curve,
          });
        }
      });
    } else if (attr === 'size') {
      this.setState({
        curve: '',
      });
    }
  };

  onChangeDualList = (selected) => {
    this.setState({ selected });
  };

  setValue = async (attr, value) => {
    if (attr === 'curves') {
      const selectedValues = Array.isArray(value) ? value : [];

      const hasAll = selectedValues.some((item) => item.value === 'all');

      if (hasAll) {
        this.setState({
          curves: [
            {
              value: 'all',
              label: I18n.t('BEE2478' /* Todas as curvas estão selecionadas */),
            },
          ],
        });
      } else {
        this.setState({ curves: selectedValues });
      }

    } else {
      this.setState({
        [`${attr}`]: value,
      });
    }
  };

  onGenerateSpreadsheet = () => {
    const {
      selected,
      branchCodeFrom,
      branchCodeTo,
      codeFrom,
      codeTo,
      sectorFrom,
      sectorTo,
      streetFrom,
      streetTo,
      columnFrom,
      columnTo,
      columnSide,
      levelFrom,
      levelTo,
      drawerFrom,
      drawerTo,
      rangeFrom,
      rangeTo,
      type,
      storageAddressSize,
    } = this.state;

    const { location } = this.props;

    const headers = selected.map((it) => ({ ...(this.options.find((itb) => itb.value === it) || {}) }));

    const curve = this.state.curves.some((c) => c.value === 'all')
      ? this.state.listCurves
        .filter((c) => c.value !== 'all')
        .map((c) => c.label)
      : this.state.curves
        .map((c) => c.label);

    const filters = returnFiltersByRules([
      ['columnSide', { value: columnSide }],
      ['curve', { type: 'in', value: curve }],
      ['type', { type: 'in', value: (type === '') ? '' : [type] }],
      ['branchCode', { type: 'between', value: [branchCodeFrom, branchCodeTo] }],
      ['code', { type: 'between', value: [codeFrom.toLocaleUpperCase(), codeTo.toLocaleUpperCase()] }],
      ['sector', { type: 'between', value: [sectorFrom.toLocaleUpperCase(), sectorTo.toLocaleUpperCase()] }],
      ['street', { type: 'between', value: [streetFrom.toLocaleUpperCase(), streetTo.toLocaleUpperCase()] }],
      ['column', { type: 'between', value: [columnFrom.toLocaleUpperCase(), columnTo.toLocaleUpperCase()] }],
      ['level', { type: 'between', value: [levelFrom.toLocaleUpperCase(), levelTo.toLocaleUpperCase()] }],
      ['drawer', { type: 'between', value: [drawerFrom.toLocaleUpperCase(), drawerTo.toLocaleUpperCase()] }],
      ['rangeCode', { type: 'between', value: [rangeFrom, rangeTo] }],
      ['size', { type: 'in', value: (storageAddressSize === '') ? '' : [storageAddressSize] }],
    ]);

    this.props.generateReport(
      I18n.t('BEE1753' /* Endereços Vazios */).toLowerCase(),
      'xlsx',
      location.pathname,
      headers,
      filters,
    );
  };

  onSelectFilter = (newState) => this.setState({ ...newState });

  render() {
    const {
      selected,
      branchCodeFrom,
      branchCodeTo,
      codeFrom,
      codeTo,
      sectorFrom,
      sectorTo,
      streetFrom,
      streetTo,
      columnFrom,
      columnTo,
      columnSide,
      columnSideList,
      columnSideLabel,
      levelFrom,
      levelTo,
      drawerFrom,
      drawerTo,
      rangeFrom,
      rangeTo,
      type,
      typeName,
      listType,
      storageAddressSize,
      storageAddressSizeName,
      listStorageAddressSize,
      disableStorageAddressSize,
    } = this.state;

    const { location = {} } = this.props;

    return (
      <PanelPage
        breadcrumb={this.breadcrumb}
        title={`${I18n.t('BEE528' /* Relatório */)} - ${I18n.t('BEE1753' /* Endereços Vazios */)}`}
        wikiHelp={ROUTES.REPORT_HELP}
        content={(
          <div style={{ marginLeft: 20, marginRight: 20 }}>
            <FilterDefault stateToSave={this.state} route={location.pathname} onSelectFilter={this.onSelectFilter} />
            <div className="d-flex mb-md-4 mb-4 mt-4" />
            <DualList
              id="dualselect"
              options={this.options}
              selected={selected}
              onChange={this.onChangeDualList}
              preserveSelectOrder
              showOrderButtons
              showHeaderLabels
            />
            <div className="d-flex align-items-center mb-md-3 mb-1 mt-5">
              <h1 className="page-header mb-0">
                {I18n.t('BEE546' /* Filtros */)}
              </h1>
            </div>
            <hr />
            <div style={{ marginTop: 30 }}>
              <Form
                noPanel
                leftType
                setValue={this.setValue}
                setValueDrop={this.setValueDrop}
                inputs={(formContext) => ([
                  formContext.createInputRange(
                    { from: branchCodeFrom, to: branchCodeTo },
                    { from: 'branchCodeFrom', to: 'branchCodeTo' },
                    `${I18n.t('BEE145' /* Filial */)}:`,
                    { from: '', to: 'Z'.repeat(10) },
                  ),
                  formContext.createInputRange(
                    { from: codeFrom.toLocaleUpperCase(), to: codeTo.toLocaleUpperCase() },
                    { from: 'codeFrom', to: 'codeTo' },
                    `${I18n.t('BEE82' /* Código */)}:`,
                    { from: '', to: 'Z'.repeat(20) },
                  ),
                  formContext.createInputRange(
                    { from: rangeFrom, to: rangeTo },
                    { from: 'rangeFrom', to: 'rangeTo' },
                    `${I18n.t('BEE581' /* Range */)}:`,
                    { from: '', to: 'Z'.repeat(20) },
                  ),
                  formContext.createInputRange(
                    { from: sectorFrom.toLocaleUpperCase(), to: sectorTo.toLocaleUpperCase() },
                    { from: 'sectorFrom', to: 'sectorTo' },
                    `${I18n.t('BEE1854' /* Setor */)}:`,
                    { from: '', to: 'Z'.repeat(20) },
                  ),
                  formContext.createInputRange(
                    { from: streetFrom.toLocaleUpperCase(), to: streetTo.toLocaleUpperCase() },
                    { from: 'streetFrom', to: 'streetTo' },
                    `${I18n.t('BEE121' /* Rua */)}:`,
                    { from: '', to: 'Z'.repeat(30) },
                  ),
                  formContext.createInputRange(
                    { from: columnFrom.toLocaleUpperCase(), to: columnTo.toLocaleUpperCase() },
                    { from: 'columnFrom', to: 'columnTo' },
                    `${I18n.t('BEE281' /* Coluna */)}:`,
                    { from: '', to: 'Z'.repeat(30) },
                  ),
                  formContext.createSelectDropDown(
                    { value: columnSide, label: columnSideLabel },
                    'columnSide',
                    `${I18n.t('BEE3397' /* Gerar Lados (Coluna) */)}:`,
                    columnSideList,
                    false,
                  ),
                  formContext.createInputRange(
                    { from: levelFrom.toLocaleUpperCase(), to: levelTo.toLocaleUpperCase() },
                    { from: 'levelFrom', to: 'levelTo' },
                    `${I18n.t('BEE283' /* Nível */)}:`,
                    { from: '', to: 'Z'.repeat(30) },
                  ),
                  formContext.createInputRange(
                    { from: drawerFrom.toLocaleUpperCase(), to: drawerTo.toLocaleUpperCase() },
                    { from: 'drawerFrom', to: 'drawerTo' },
                    `${I18n.t('BEE285' /* Gaveta */)}:`,
                    { from: '', to: 'Z'.repeat(30) },
                  ),
                  formContext.createSelectDropDown(
                    { value: storageAddressSize, label: storageAddressSizeName },
                    'storageAddressSize',
                    `${I18n.t('BEE1491' /* Classificação de Endereço */)}:`,
                    listStorageAddressSize,
                    disableStorageAddressSize,
                  ),
                  formContext.createSelectDropDownMulti(
                    this.state.curves,
                    `${I18n.t('BEE355' /* Curva */)}:`,
                    'curves',
                    this.state.listCurves,
                    undefined,
                    ['col-md-2', 'col-md-4'],
                    false,
                  ),

                  this.createSelectDropDown(
                    { value: type, label: typeName },
                    'type',
                    `${I18n.t('BEE200' /* Tipo */)}:`,
                    listType,
                    true,
                  ),
                ])}
              />
            </div>
            <ReportsBackgroundModal />
          </div>
        )}
        footerContent={(
          <OneClickButton
            type="button"
            style={{ width: 'auto', padding: 10 }}
            className="btn btn-primary p-5 m-5"
            onClick={this.onGenerateSpreadsheet}
          >
            {I18n.t('BEE544' /* Gerar Planilha */)}
          </OneClickButton>
        )}
      />
    );
  }
}

const colourStyles = {
  control: (styles) => ({ ...styles, backgroundColor: 'white' }),
  option: (styles, {
    data, isDisabled, isFocused, isSelected,
  }) => ({
    ...styles,
    backgroundColor: isDisabled ? 'grey' : 'white',
    color: isDisabled ? 'grey' : 'black',
    cursor: isDisabled ? 'not-allowed' : 'default',
    textAlign: 'left',
    ':hover': {
      ...styles[':hover'],
      backgroundColor: isSelected ? 'grey' : '#eb900a',
      color: 'white',
    },
  }),
};

const mapStateToProps = (state) => ({
  curves: state.curves?.curvesList,
});
const mapDispatchToProps = (dispatch) => ({
  getCapacityOptions: () => dispatch(getCapacityOptions()),
  generateReport: (
    nameDoc,
    type,
    route,
    columns,
    filters,
  ) => dispatch(generateReport(nameDoc, type, route, columns, filters)),
  getStorageAddressTypesOptions: () => dispatch(getStorageAddressTypesOptions()),
  getAllCurves: () => dispatch(getAllCurves()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportStockEmptyAddresses);
